import { render } from "./logo-mastercard.vue?vue&type=template&id=298a70f0&scoped=true"
import script from "./logo-mastercard.js?vue&type=script&lang=js&external"
export * from "./logo-mastercard.js?vue&type=script&lang=js&external"

import "./logo-mastercard.scss?vue&type=style&index=0&id=298a70f0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298a70f0"]])

export default __exports__